import { useState } from 'react';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import { VscLoading } from 'react-icons/vsc';
import { fetchWrapper } from '../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../_helpers/_methods';
import { BsFilePdf } from 'react-icons/bs';
import { FaRegFileExcel } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';

function DownloadBtn({ apiUrl, type, className }) {
  const [loading, setLoading] = useState(false);
  const handleExport = async () => {
    try {
      setLoading(true);
      const response = await fetchWrapper.get(apiUrl);
      let data = response.data;
      const element = document.createElement('a');
      element.href = data.file;
      element.click();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      ErrorMessageHandler(err);
    }
  };

  const handleUpdatedExport = async () => {
    try {
      setLoading(true);
      const response = await fetchWrapper.get(apiUrl + '&nocache=true');
      let data = response.data;
      const element = document.createElement('a');
      element.href = data.file;
      element.click();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      ErrorMessageHandler(err);
    }
  };

  let render;
  switch (type) {
    case 'pdf':
      render = (
        <span>
          <BsFilePdf className="me-2" />
          Export to pdf
        </span>
      );
      break;
    case 'excel':
      render = (
        <span>
          <FaRegFileExcel className="me-2" />
          Export to Excel
        </span>
      );
      break;
    default:
      break;
  }
  return (
    <Dropdown as={ButtonGroup} className="ms-2">
      <Button variant="outline-success btn-sm" className={`${className}`} onClick={handleExport}>
        {loading ? <VscLoading className="spin" /> : render}
      </Button>

      <Dropdown.Toggle split variant="outline-success btn-sm" id="dropdown-split-basic" />
      <Dropdown.Menu>
        <Dropdown.Item eventKey="1" onClick={handleUpdatedExport}>
          <FormattedMessage id="button.updated_data" />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DownloadBtn;
